'use client';

import Link from 'next/link';
import { type JSX } from 'react';

/**
 * Shown over the conversational search experience when a signed-in user's
 * subscription has lapsed. No sign-in link — the user is already authenticated
 * to reach this screen.
 */
export function ReactivationModal({ reactivateHref = '/pricing' }: { reactivateHref?: string }): JSX.Element {
    return (
        <div className="pointer-events-none fixed inset-0 z-10 flex items-center justify-center lg:absolute">
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="reactivation-modal-title"
                className="pointer-events-auto flex flex-col gap-10 bg-white rounded-sm w-full max-w-md mx-4 p-8 shadow-2xl"
            >
                <h2 id="reactivation-modal-title" className="text-2xl font-bold leading-tight text-gray-900">
                    To use Conversational Search, please reactivate your subscription.
                </h2>
                <Link
                    href={reactivateHref}
                    className="flex w-full items-center justify-center rounded-sm bg-yellow-400 px-6 py-2.5 text-sm font-semibold text-gray-900 transition-colors hover:bg-yellow-600"
                >
                    Subscribe to continue
                </Link>
            </div>
        </div>
    );
}
